export const publicAssetUrlMaximumLength = 2048;
const sensitiveQueryKeys = new Set([
  'auth',
  'code',
  'googleaccessid',
  'key',
  'oauth',
  'sig',
  'signature'
]);
const sensitiveQueryKeyFragments = [
  'accesskey',
  'apikey',
  'authorization',
  'credential',
  'password',
  'privatekey',
  'secret',
  'token'
];

function containsControlCharacter(value: string) {
  return Array.from(value).some((character) => {
    const codePoint = character.codePointAt(0) ?? 0;

    return codePoint <= 31 || (codePoint >= 127 && codePoint <= 159);
  });
}

function containsSensitiveQueryKey(url: URL) {
  return Array.from(url.searchParams.keys()).some((key) => {
    const normalizedKey = key.toLowerCase().replace(/[^a-z0-9]/g, '');

    return (
      normalizedKey.startsWith('xamz') ||
      normalizedKey.startsWith('xgoog') ||
      sensitiveQueryKeys.has(normalizedKey) ||
      sensitiveQueryKeyFragments.some((fragment) =>
        normalizedKey.includes(fragment)
      )
    );
  });
}

export function normalizePublicAssetUrl(value?: string | null) {
  const normalized = value?.trim();

  if (
    !normalized ||
    normalized.length > publicAssetUrlMaximumLength ||
    containsControlCharacter(normalized) ||
    normalized.includes('#') ||
    /[\\<>]/.test(normalized)
  ) {
    return undefined;
  }

  if (normalized.startsWith('/')) {
    if (normalized.startsWith('//')) return undefined;

    try {
      return containsSensitiveQueryKey(
        new URL(normalized, 'https://public-assets.hsdesk.local')
      )
        ? undefined
        : normalized;
    } catch {
      return undefined;
    }
  }

  try {
    const url = new URL(normalized);

    return (url.protocol === 'https:' || url.protocol === 'http:') &&
      url.hostname &&
      !url.username &&
      !url.password &&
      !containsSensitiveQueryKey(url)
      ? normalized
      : undefined;
  } catch {
    return undefined;
  }
}

export function isSafePublicAssetUrlOrEmpty(value?: string | null) {
  return !value?.trim() || Boolean(normalizePublicAssetUrl(value));
}
